import mongoose from 'mongoose'

export const categoriesSchema = mongoose.Schema({
	name:{
		type:String,
		required:true
	},
	description:{
		type:String,

	},
	wallet:{
		type:mongoose.Schema.Types.ObjectId,
		ref:"Wallet"
	}

},{ collection: 'categories' })
export default mongoose.model('Categories',categoriesSchema)